import { Col, Picture, Row, Button, Banner, Typography } from 'darrius';

import { Header } from '../../components/atoms';
import { HeadContent } from '../../components';
import { type IDocumentsValidationProps } from './@interfaces';

import styles from './ManualDocumentsValidation.module.scss';

const APP_LINK =
  'https://api-mobile.getninjas.com.br/api/v1/conversions/redirect_to_download_page/pro?utm_source=validacao_doc&utm_medium=getninjas&utm_campaign=validacao_doc_webcheckout';

export default function ManualDocumentsValidation({
  validation,
}: IDocumentsValidationProps) {
  return (
    <>
      <HeadContent
        metaTitle="GetNinjas | Orçamento de Profissionais Confiáveis no GetNinjas.com.br"
        slug="validacao-de-documentos-manual"
        metaDescription="Encontre profissionais confiáveis para pintar, reformar, traduzir um texto, te ensinar matemática, ou também passear com seu cachorro no GetNinjas"
        type="document-validation-manual:show"
        noindex
      />

      <Header.Simple />

      <main
        className={`register-success space-top space-bottom ${styles['register-success']}`}
      >
        <Banner>
          <Row className="center-sm">
            <Col className="col-sm-5 col-md-2">
              <Picture
                className={styles['icon-big']}
                src={{
                  sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/documents-validation.svg`,
                  md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/documents-validation.svg`,
                  lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/documents-validation.svg`,
                }}
              />
            </Col>
          </Row>

          <Row className="center-sm">
            <Col className="col-md-6">
              <Typography.Title size="3xl">
                Valide seus documentos
              </Typography.Title>
              <Typography.Text className={styles.text}>
                Para continuar usando o GetNinjas, você precisa validar seus
                documentos. Isso garante a segurança dos clientes e dos
                profissionais. Acesse o aplicativo para fazer o processo de
                validação
              </Typography.Text>
            </Col>
          </Row>

          <Row className="center-sm space-between">
            <Col className="col-sm-12 col-md-4">
              <Button.Link
                variation="primary"
                size="small"
                fullWidth
                href={APP_LINK}
              >
                Ir para o APP
              </Button.Link>
            </Col>
          </Row>
        </Banner>
      </main>
    </>
  );
}
